import React from 'react'

const LoginLog = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Login Log</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">System Logs</li>
            <li className="breadcrumb-item active">Login Log</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Login Log</h5>
                <p>View and audit all user login and logout activities.</p>
                {/* Add login log table/component here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default LoginLog

